<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- AIOT上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>AIOT</h1>
            <ul>
              <li>全息万物互联</li>
              <li>赋能空间服务</li>
              <li>空间信息与业务数据融合</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <!-- 万物互联 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space scene_park">
            <div class="title">
              <h3>万物互联</h3>
            </div>
            <el-row>
              <el-col :span="7">
                <div class="content content_left">
                  <ul>
                    <li>
                      <img src="~@/assets/images/AI2.png" />
                      <span>多源异构整合</span>
                    </li>
                    <li>
                      <img src="~@/assets/images/AI3.png" />
                      <span>快速灵活，安全可靠</span>
                    </li>
                    <li>
                      <img src="~@/assets/images/AI4.png" />
                      <span>云、边、端与业务数据实时互通</span>
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="content_picture">
                  <img src="~@/assets/images/AI8.png" />
                </div>
              </el-col>
              <el-col :span="7">
                <div class="content content_right">
                  <ul>
                    <li>
                      <span>边缘计算能力</span>
                      <img src="~@/assets/images/AI5.png" />
                    </li>
                    <li>
                      <span>多端多协议解析</span>
                      <img src="~@/assets/images/AI6.png" />
                    </li>
                    <li>
                      <span>自主对接，设备即插即用</span>
                      <img src="~@/assets/images/AI7.png" />
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 智能硬件 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space Intelligent_hardware">
            <div class="title">
              <h3>智能硬件</h3>
            </div>
            <el-row>
              <el-col :span="24" style="background: #fff">
                <el-tabs
                  v-model="activeName"
                  type="card"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="网关/机器人" name="first">
                    <div class="robot_list">
                      <div class="layway_listLeft">
                        <div class="layway_listLeftImg">
                          <img src="~@/assets/images/wangguan.png" />
                        </div>
                        <ul>
                          <li>
                            <h4>快速灵活</h4>
                            <p>集成多种接口、协议，灵活配置</p>
                          </li>
                          <li>
                            <h4>安全可靠</h4>
                            <p>双网双天线，数据加密传输，不掉线</p>
                          </li>
                          <li>
                            <h4>便捷运维</h4>
                            <p>跨平台部署，即插即用</p>
                          </li>
                        </ul>
                      </div>
                      <div class="layway_listRight">
                        <img src="~@/assets/images/jiqiren.png" />
                        <ul>
                          <li>
                            <h4>自动迎宾</h4>
                          </li>
                          <li>
                            <h4>引领带路</h4>
                          </li>
                          <li>
                            <h4>互动讲解</h4>
                          </li>
                          <li>
                            <h4>巡游展播</h4>
                          </li>
                          <li>
                            <h4>自主编程</h4>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="智能安防" name="second">
                    <ul class="layway_list">
                      <li>
                        <img src="~@/assets/images/anfang1.png" />
                        <p>WD1252H21-I1VF</p>
                        <p>人脸比对红外摄像机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/anfang2.png" />
                        <p>WD1252H31-I1VF</p>
                        <p>人脸比对红外摄像机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/anfang3.png" />
                        <p>WD1252H51-PC</p>
                        <p>低照全彩人脸比对摄像机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/anfang4.png" />
                        <p>WD1252H51-PX</p>
                        <p>星光全彩人脸比对摄像机</p>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <el-tab-pane label="智能门禁" name="third">
                    <ul class="layway_list">
                      <li>
                        <img src="~@/assets/images/menjin1.png" />
                        <p>WD2112H21-L</p>
                        <p>5寸双目人脸门禁一体机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/menjin2.png" />
                        <p>WD2122S41-L</p>
                        <p>7寸双目人脸门禁一体机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/menjin3.png" />
                        <p>WD2232H31-L</p>
                        <p>8寸双目人脸门禁一体机</p>
                      </li>
                    </ul>
                  </el-tab-pane>
                  <el-tab-pane label="智能停车" name="fourth">
                    <ul class="layway_list">
                      <li>
                        <img src="~@/assets/images/AI9.png" />
                        <p>WD3221H1</p>
                        <p>200万高清车辆识别一体机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/AI9.png" />
                        <p>WD3231H1</p>
                        <p>300万高清车辆识别一体机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/AI9.png" />
                        <p>WD3221H1-X</p>
                        <p>200万星光级高清车辆识别一体机</p>
                      </li>
                      <li>
                        <img src="~@/assets/images/AI10.png" />
                        <p>WD3322H1-EXAF</p>
                        <p>ETC车牌双模识别一体机</p>
                      </li>
                    </ul>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/AI1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 255px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      ul {
        margin-left: 20px;
      }
      ul li {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        color: #ffffff;
        float: left;
        margin-right: 57px;
      }
    }
  }

  //核心功能
  .content_space {
    background: #fafafa;
    padding: 48px 234px 85px 255px;
    h3 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 23px;
    }
    > p {
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      line-height: 32px;
      width: 208px;
      margin: auto;
    }
    .content {
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        margin: 43px 0 44px 0;
      }
    }
    .content_left {
      ul {
        li {
          list-style: none;
          display: flex;
          margin-bottom: 65px;
          justify-content: end;
          align-items: center;
          height: 52px;
          span {
            margin-left: 60px;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
          }
        }
      }
    }
    .content_right {
      ul {
        li {
          list-style: none;
          display: flex;
          margin-bottom: 65px;
          justify-content: flex-end;
          align-items: center;
          height: 52px;
          span {
            margin-right: 60px;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
          }
        }
      }
    }
  }

  // 业务痛点
  .scene_park {
    background: #fff;
    padding: 71px 234px 54px 255px;
    h3 {
      margin-bottom: 73px;
    }

    img {
      max-width: 345px;
      max-height: 362px;
    }
  }

  .robot_list {
    display: flex;
    padding: 72px 81px 79px 83px;
    justify-content: space-around;
    > div {
      font-size: initial;
      display: flex;
      align-items: center;
      ul {
        margin-left: 50px;
        li {
          list-style: none;
          text-align: left;
          h4 {
            font-size: 18px;
          }
          p {
            margin: 10px 0 30px 0;
          }
        }
      }
    }

    .layway_listRight {
      h4 {
        margin-bottom: 30px;
      }

      img {
        max-width: 323px;
        max-height: 294px;
      }
    }
  }

  .layway_list {
    display: flex;
    padding: 72px 81px 79px 83px;
    justify-content: space-between;
    li {
      list-style: none;
      border: 1px #f0f0f6 solid;
      font-weight: 400;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      padding: 46px 31px 35px 32px;
      > p:nth-of-type(1) {
        color: #fe5f28;
        padding: 29px 0 23px 0;
      }
    }
  }

  .layway_listLeftImg {
    img {
      max-width: 256px;
      max-height: 164px;
    }
  }
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .robot_list > div ul {
      font-size: small !important;
    }

    .content_space {
      // background: #fafafa;
      padding: 0.25rem 1.1875rem 0.442708rem 1.328125rem;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "AIOT-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content:
          "AIOT,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content:
          "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能AIOT可实现全息万物互联、赋能空间服务、空间信息与业务数据融合。",
      },
    ],
  },
  data() {
    return {
      activeName: "first", //选中标签页
      tabIndex: "2-6",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  computed: {},
};
</script>